import { Injectable } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';

import { HeaderService } from '../Services/header.service';

import * as QuillNS from 'quill';
import Delta from 'quill-delta/lib/delta';

@Injectable({
  providedIn: 'root'
})
export class QuillService {
  QuillType: any = QuillNS;

  Font = this.QuillType.import('formats/font');
  Size = this.QuillType.import('attributors/style/size');
  Link = this.QuillType.import('formats/link');

  quill: any;
  toolbarOptions = [
    [{ font: ['', 'arial', 'times-new-roman', 'verdana'] }],
    [{ size: ['', '8px', '10px', '14px', '16px', '18px', '20px', '24px', '28px', '36px'] }],
    ['bold', 'italic', 'underline', 'strike'],    // toggled buttons
    ['blockquote'],
    [{ list: 'ordered' }, { list: 'bullet' }],
    [{ script: 'sub' }, { script: 'super' }],     // superscript/subscript
    [{ indent: '-1' }, { indent: '+1' }],         // outdent/indent
    [{ direction: 'rtl' }],                       // text direction

    [{ header: [1, 2, 3, false] }],
    ['link', 'image', 'video'],
    [{ color: [] }, { background: [] }],          // dropdown with defaults from theme

    [{ align: [] }],

    ['clean']                                     // button to remove formatting
  ];

  defaultDelta: object = {
    ops: [
      { attributes: { underline: true }, insert: 'Enhancements' },
      { attributes: { header: 2 }, insert: '\n' },
      { insert: 'Item Headline:' },
      { attributes: { header: 3 }, insert: '\n' },
      { insert: 'Description of new feature and how to use it.' },
      { attributes: { list: 'bullet' }, insert: '\n' },
      { insert: 'Item Headline:' },
      { attributes: { header: 3 }, insert: '\n' },
      { insert: 'Description of new feature and how to use it.' },
      { attributes: { list: 'bullet' }, insert: '\n' },
      { insert: '\n' },
      { attributes: { underline: true }, insert: 'Fixes' },
      { attributes: { header: 2 }, insert: '\n' },
      { insert: 'Public friendly issue description' },
      { attributes: { list: 'bullet' }, insert: '\n' },
      { insert: 'Public friendly issue description' },
      { attributes: { list: 'bullet' }, insert: '\n' },
      { insert: '\n' },
      { attributes: { underline: true }, insert: 'Help Desk ticket corrected in Release' },
      { attributes: { header: 2 }, insert: '\n' },
      { insert: 'List IR or SR number(s)' },
      { attributes: { list: 'bullet' }, insert: '\n' },
    ]
  };

  constructor(protected Sanitizer: DomSanitizer, private headerService: HeaderService) {
    this.setToolbarOpts();
  }

  getEmailDelta(version: string, date: Date) {
    return { ops: [
        { insert: 'The notes for release ' + version + ' have been published and can be found ' },
        { attributes: { link: 'https://webapps.harriscountytx.gov/ReleaseNotes/applications' }, insert: 'here' },
        { insert: '.\n' },
        { insert: 'The release will be deployed on ' + date + '.\n' },
        { insert: '\n' },
        { insert: 'If you encounter any issues following the deployment, please contact Universal Services Help Desk at ' },
        { attributes: { link: 'HelpDesk@HarrisCountyTx.Gov' }, insert: 'HelpDesk@HarrisCountyTx.Gov' },
        { insert: '.\n' },
        { insert: '\n' },
        { insert: 'Thank You,\n' },
        { insert: '\n' },
        { insert: { image: '../../assets/HCUS-logo-300x300px.png' }, attributes: { width: '75px' } },
        { insert: 'Universal Services\n 713-274-4444\n' }
      ]
    };
  }

  quillSetupEntry() {
    this.Link.sanitize = (url: string) => {
      if (!url.match(/^(\/|http(s)?:\/\/)/)) {
        url = `http://${url}`;
      }
      return url;
    };

    function matchMsWordList(node, delta) {

      // Clone the operations
      const ops = delta.ops.map((op) => Object.assign({}, op));

      // Trim the front of the first op to remove the bullet/number
      const bulletOp = ops.find((op) => op.insert && op.insert.trim().length);

      if (!bulletOp) { return delta; }

      bulletOp.insert = bulletOp.insert.trimLeft();
      const listPrefix = bulletOp.insert.match(/^.*?(^·|\.)/) || bulletOp.insert[0];
      bulletOp.insert = bulletOp.insert.substring(listPrefix[0].length, bulletOp.insert.length).trimLeft();

      // Trim the newline off the last op
      const last = ops[ops.length - 1];
      last.insert = last.insert.substring(0, last.insert.length - 1);

      // Determine the list type
      const listType = listPrefix[0].length === 1 ? 'bullet' : 'ordered';

      //console.log('TRIGGER3');
      //console.log(bulletOp);
      //console.log(listPrefix);
      //console.log(last);
      //console.log(listType);

      // Determine the list indent
      const style = node.getAttribute('style').replace(/\n+/g, '');
      const levelMatch = style.match(/level(\d+)/);
      const indent = levelMatch ? levelMatch[1] - 1 : 0;

      // Add the list attribute
      ops.push({ insert: '\n', attributes: { list: listType, indent } });

      return new Delta(ops);
    }

    function maybeMatchMsWordList(node, delta) {
      if (delta.ops[0].insert.trimLeft()[0] === '·') {
        return matchMsWordList(node, delta);
      }

      return delta;
    }

    const MSWORD_MATCHERS = [
      ['p', matchMsWordList],
      ['p.msolistparagraph', matchMsWordList],
      ['p.MsoNormal', maybeMatchMsWordList]
    ];


    /*clipboard: { matchers: MSWORD_MATCHERS }*/

    const opts: QuillNS.QuillOptionsStatic = {
      theme: 'snow',
      modules: {
        toolbar: this.toolbarOptions,
        clipboard: { matchers: MSWORD_MATCHERS }
      }
    };

    this.quill = new this.QuillType('#editor', opts);
    this.quill.setContents(null);
  }

  quillDisableEdit() {
    this.quill.enable(false);
  }

  quillEnableEdit() {
    this.quill.enable(true);
  }

  quillSetupDisplay(editor, delta) {
    const obj = this.HighlightSearchTerm(delta);

    const opts: QuillNS.QuillOptionsStatic = {
      theme: 'snow',
      modules: {
        toolbar: false
      }
    };

    this.quill = new this.QuillType(editor, opts);
    this.quill.setContents(obj);
    this.quill.enable(false);
  }

  quillSetupEmailDisplay(editor, delta) {
    const opts: QuillNS.QuillOptionsStatic = {
      theme: 'snow',
      modules: {
        toolbar: false
      }
    };

    this.quill = new this.QuillType(editor, opts);
    this.quill.setContents(delta);
    this.quill.enable(false);
  }

  setToolbarOpts() {
    this.Font.whitelist = ['helvetica', 'arial', 'times-new-roman', 'verdana'];
    this.Size.whitelist = ['8px', '10px', '14px', '16px', '18px', '20px', '24px', '28px', '36px'];
    this.QuillType.register(this.Font, true);
    this.QuillType.register(this.Size, true);
  }

  getHTML(inputDelta) {
    const tempCont = document.createElement('div');
    (new this.QuillType(tempCont)).setContents(inputDelta);
    return tempCont.getElementsByClassName('ql-editor')[0].innerHTML;
  }

  HighlightSearchTerm(delta): JSON {
    const search = this.headerService.searchTerm;
    if (search && search.trim() !== '') {
      // Regex will match all insert attribute values (text to be displayed) that contain the search string
      const searchTerm: RegExp = new RegExp(search, 'gi');
      const newOps: any = new Object({ ops: [] });
      let i = 0;

      for (const entry of delta.ops) {
        if (typeof entry.insert === 'string' && searchTerm.test(entry.insert)) {
          const newEntries: object[] = this.SplitSetwithStyle(entry, searchTerm);
          for (const ent of newEntries) {
            newOps.ops[i] = ent;
            ++i;
          }
        } else {
          newOps.ops[i] = entry;
          ++i;
        }
      }

      delta = newOps;
    }

    return delta;
  }

  SplitSetwithStyle(entry, pattern: RegExp): object[] {
    let entries: object[] = [];
    let workString: string = entry.insert;
    let leftover: string;

    while (workString) {
      pattern.lastIndex = 0;
      const text: RegExpExecArray = pattern.exec(workString);
      let t: string;
      let indexOfMatch;

      if (text) {
        t = text[0];
        indexOfMatch = workString.indexOf(t);
      } else {
        indexOfMatch = workString.length - 1;
      }

      if (!text || indexOfMatch > 0) {
        leftover = text ? workString.substring(indexOfMatch) : null;
        workString = workString.replace(leftover, '');

        entries = this.pushEntry(entries, entry.attributes, workString);
      } else if (indexOfMatch === 0) {
        const highlight = this.dupeAttributesWithHighlight(entry.attributes);
        leftover = workString.substring(t.length);
        workString = workString.substring(0, t.length);

        entries = this.pushEntry(entries, highlight, workString);
      }

      workString = leftover;
    }

    return entries;
  }

  pushEntry(entries, attributes, insert): object[] {
    entries.push({ attributes, insert });
    return entries;
  }

  dupeAttributesWithHighlight(attributes: any): any {
    let newAttributes;
    if (attributes) {
      newAttributes = JSON.parse(JSON.stringify(attributes));
      if (newAttributes.header) { delete newAttributes.header; }
      if (newAttributes.list) { delete newAttributes.list; }
      if (newAttributes.align) { delete newAttributes.align; }
    }
    if (!attributes) {
      newAttributes = new Object();
    }

    newAttributes.background = '#ffff00';
    return newAttributes;
  }
}
